import React, { useEffect, Fragment, useState } from "react";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import Swal from "sweetalert2";
import { DeleteRoomCategory, GetRoomCategories } from "../../../../api/ipd/roomCategoryAPI";

const ListRoomCategory = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const fetchStates = async data => {
    dispatch({ type: "LOADER_START" });
    try {
      const response = await GetRoomCategories(data); // Make sure login function returns token
      
      if (response.success) {
        showToast("success", response.message);
        const formattedData = response.data.map((item, index) => ({
          index: index + 1,
          id: item._id,
          name: item.name || "",
          noOfRooms: item.noOfRooms || "",
          billingCharges: item.billingChargesId?.name || ""
        }));
        setData(formattedData);
        setFilteredData(formattedData);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  useEffect(() => {
    fetchStates();
  }, []);

  useEffect(
    () => {
      const results = data.filter(item =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    );
    setFilteredData(results);
    },
    [search, data]
  );

  const handleEditClick = id => {
    navigate(`/ipd/master/room-category/edit/${id}`);
  };

  const handleDeleteClick = async id => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then(async result => {
      if (result.isConfirmed) {
        dispatch({ type: "LOADER_START" });
        try {
          const response = await DeleteRoomCategory(id);
          if (response.success) {
            showToast("success", response.message);
            setData(data.filter(item => item.id !== id));
            setFilteredData(filteredData.filter(item => item.id !== id));
          } else {
            showToast("error", response.message);
          }
        } catch (error) {
          console.error("Error deleting room category:", error);
          showToast("error", error);
        } finally {
          dispatch({ type: "LOADER_STOP" });
        }
      }
    });
  };

  const columns = [
    { name: "S.No", selector: row => row.index, sortable: true, width: "10%" },
    {
      name: "Name",
      selector: row => row.name,
      sortable: true,
      width: "20%"
    },
    {
      name: "No of Rooms",
      selector: row => row.noOfRooms,
      sortable: true,
      width: "20%"
    },
    {
      name: "Billing Charges",
      selector: row => row.billingCharges,
      sortable: true,
      width: "20%"
    },
    {
      name: "Actions",
      cell: row =>
        <div>
          <button
            className="btn btn-primary me-2"
            onClick={() => handleEditClick(row.id)}
            id="edit"
          >
            <i className="fa fa-pencil-square-o" />
          </button>
          <UncontrolledTooltip placement="top" target="edit">
            Edit
          </UncontrolledTooltip>
          <button
            className="btn btn-danger"
            onClick={() => handleDeleteClick(row.id)}
            id="delete"
          >
            <i className="fa fa-trash-o" />
          </button>
          <UncontrolledTooltip placement="top" target="delete">
            Delete
          </UncontrolledTooltip>
        </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "20%"
    }
  ];

  const headers = [
    { label: "S.No", key: "index" },
    { label: "Name", key: "name" },
    { label: "No of Rooms", key: "noOfRooms" },
    { label: "Billing Charges", key: "billingCharges" }
  ];

  const ExportCSV = ({ data }) =>
    <CSVLink data={data} headers={headers} filename="room-categories.csv">
      <button
        className="btn btn-primary"
        id="export"
        style={{ marginTop: "5px" }}
      >
        Export
      </button>
      <UncontrolledTooltip placement="top" target="export">
        Export to CSV
      </UncontrolledTooltip>
    </CSVLink>;

  return (
    <Fragment>
      <Breadcrumb parent="Room Category" title="List Room Category" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>List Room Category</h5>
                  <Link to={`/ipd/master/room-category/add`}>
                    <button className="btn btn-primary" id="create">
                      Create Room Category
                    </button>
                    <UncontrolledTooltip placement="top" target="create">
                      Create Room Category
                    </UncontrolledTooltip>
                  </Link>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search Room Category..."
                      value={search}
                      onChange={e => setSearch(e.target.value)}
                      style={{ marginTop: "5px" }}
                    />
                  </div>
                  <div className="col-sm-6 text-end">
                    <ExportCSV data={data} />
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    highlightOnHover
                  />{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ListRoomCategory;
